import { onboardingConstants } from "../../constants/constants";
const initState = getLocalState('onboardingReducer') || {
    sessionId: '',
    //step 2
    timeZones: []
}
const onboardingReducer = (state = initState, action) => {
    switch (action.type) {
        case onboardingConstants.ONBOARDING_COMPLETE: {
            //clear
            return {
                ...state,
                sessionId: ''
            }
        }
        case onboardingConstants.ONBOARDING_SET_SESSION_ID: {
            return { ...state, sessionId: action.payload }
        }
        case onboardingConstants.ONBOARDING_SET_TIMEZONES: {
            return {...state, timeZones: action.payload}
        }
        default:
            return state;
    }
}
export default (state, action) => {
    const result = onboardingReducer(state, action);
    localStorage.setItem("onboardingReducer", JSON.stringify(result));
    return result;
};




function getLocalState(key, defaultValue = null) {
    try {
        return JSON.parse(localStorage.getItem(key))
    } catch (e) {
        return defaultValue
    }
}